type StatusDotOptions = {
    enabled: boolean;
    hasWarnings: boolean;
};

export function getEventTypeStatusDotClasses({
    enabled,
    hasWarnings,
}: StatusDotOptions): string {
    if (!enabled) {
        return "bg-red-500";
    }

    if (hasWarnings) {
        return "bg-amber-500";
    }

    return "bg-green-500";
}
